import React, { useState, useCallback } from 'react';
import PropTypes                        from 'prop-types';
import { Label }                        from 'semantic-ui-react';
import get                              from 'lodash/get';

import { getSingleton }     from 'utils/connectors';
import connectResource      from 'utils/connectResource';
import { dataGroupRecords } from 'resources/organizationResources';

import DataGroupRecordsModal  from './DataGroupRecordsModal';

// -----------------------------------------------------
// Helpers
// -----------------------------------------------------

const dataGroupsModal  = '#data-groups-modal';

function orderedDataGroupRecords({ dataGroupRecords={} }, recordType, recordId) {
  if(dataGroupRecords === null) {
    return [];
  }

  const scopedDataGroupRecords =
    get(dataGroupRecords, [recordType, recordId], {});

  return  Object
          .values(scopedDataGroupRecords)
          .sort(({ path_name: a }, { path_name: b }) => a > b ? 1 : -1);
}

const styles = {
  link:   { display: 'block' },
  label:  { float: 'right', clear: 'right' }
};

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

const DataGroupRecords = ({ data, loading, update, recordType, recordId }) => {
  const [isModalShowing, setModalShowing] = useState(false);
  const [isSaving, setSaving]             = useState(false);

  const dataGroupRecords  = orderedDataGroupRecords(data, recordType, recordId);
  const groupCount        = dataGroupRecords.length;

  // -----------------------------------------------------
  // Callbacks
  // -----------------------------------------------------

  const handleClick = (evt) => {
    evt.preventDefault();
    setModalShowing(true);
  };

  const handleClose = () => {
    setModalShowing(false);
  };

  const handleSave = useCallback(async (data_group_records, done) => {

    setSaving(true);
    const response = await update({ data_group_records }, {
      record_type:  recordType,
      record_id:    recordId
    });
    setSaving(false);

    if(!response.errors) {
      done();
    }
  }, [update, recordId, recordType]);

  return (
    <>
      <a href={ dataGroupsModal } onClick={ handleClick } style={ styles.link }>
        <span>Manage Data Groups</span>
        <Label size='mini' color='blue' circular style={ styles.label }>
          { groupCount }
        </Label>
      </a>

      <DataGroupRecordsModal  opened={ isModalShowing }
                              saving={ isSaving }
                              loading={ loading }
                              recordType={ recordType }
                              recordId={ recordId }
                              dataGroupRecords={ dataGroupRecords }
                              onSave={ handleSave }
                              onClose={ handleClose } />
    </>
  );
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

DataGroupRecords.propTypes = {
  recordType: PropTypes.string.isRequired,
  recordId:   PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
              ]).isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default connectResource(DataGroupRecords, {
  key: ({ recordType, recordId }) => [recordType, recordId].join('_'),
  connectors: {
    dataGroupRecords: getSingleton(
      dataGroupRecords,
      ({ recordType, recordId }) => ({
        record_type:  recordType,
        record_id:    recordId
      })
    )
  },
  mapDispatchToProps: {
    update: dataGroupRecords.actions.update
  }
});
